import React, { useEffect, useState } from "react";
import { Card, Table, Select, DatePicker, Space, Typography, message } from "antd";
import moment from "moment";
import DashboardLayout from "../LayoutNavbar/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../LayoutNavbar/Navbars/DashboardNavbar";
import axiosInstance from "api/axiosInstance";
import API from "api/endpoints";
import { ReportPeriodTypeEnum } from "Constants/Enums/ReportPeriodTypeEnum";

const { Text } = Typography;

const money = (v) => {
  if (v === null || v === undefined || v === "") return "-";
  const n = Number(v);
  if (Number.isNaN(n)) return "-";
  return `USD ${n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};
const fmtDate = (d) => (d ? moment(d).format("DD MMM YYYY") : "-");

const PERIOD_OPTIONS = [
  { value: "", label: "All Time" },
  { value: ReportPeriodTypeEnum.Day, label: "Day" },
  { value: ReportPeriodTypeEnum.Week, label: "Week" },
  { value: ReportPeriodTypeEnum.Month, label: "Month" },
];

// Employee proof-of-payment report (Points 7 & 8). Only Paid expenses are
// returned; the response follows the { period, data } report contract.
const ExpensePaymentReport = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [periodType, setPeriodType] = useState("");
  const [referenceDate, setReferenceDate] = useState(null);
  const [periodLabel, setPeriodLabel] = useState("");

  const load = async () => {
    try {
      setLoading(true);
      const url = API.expenseManagement.employeePaymentReport(
        periodType === "" ? null : periodType,
        referenceDate
      );
      const res = await axiosInstance.get(url);
      const body = res.data;
      const data = body && body.data !== undefined ? body.data : body;
      setRows(Array.isArray(data) ? data : []);
      setPeriodLabel(body?.period?.periodLabel || "");
    } catch (e) {
      console.error("Failed to load payment report", e);
      message.error("Failed to load payment report");
      setRows([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [periodType, referenceDate]);

  const showDatePicker = periodType !== "";
  const picker =
    periodType === ReportPeriodTypeEnum.Week
      ? "week"
      : periodType === ReportPeriodTypeEnum.Month
      ? "month"
      : "date";

  const columns = [
    { title: "S. No.", dataIndex: "serialNo", key: "serialNo" },
    { title: "Employee", dataIndex: "employeeName", key: "employeeName", render: (v) => v || "-" },
    { title: "Date Generated", key: "gen", render: (_, r) => fmtDate(r.dateGenerated) },
    { title: "Date Paid", key: "paid", render: (_, r) => fmtDate(r.datePaid) },
    { title: "Final Amount", key: "amt", render: (_, r) => money(r.finalAmount) },
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Card
        title="My Payments (Proof of Payment)"
        className="card-professional"
        style={{ margin: 16 }}
        extra={
          <Space>
            <Select
              value={periodType}
              style={{ width: 140 }}
              onChange={(v) => {
                setPeriodType(v);
                setReferenceDate(null);
              }}
              options={PERIOD_OPTIONS}
            />
            {showDatePicker && (
              <DatePicker
                picker={picker}
                onChange={(d) => setReferenceDate(d ? d.format("YYYY-MM-DD") : null)}
              />
            )}
          </Space>
        }
      >
        {periodLabel && (
          <Text type="secondary" style={{ display: "block", marginBottom: 12 }}>
            Showing: {periodLabel}
          </Text>
        )}
        <Table
          className="custom-table"
          rowKey={(r) => r.serialNo ?? `${r.employeeName}-${r.datePaid}`}
          loading={loading}
          columns={columns}
          dataSource={rows}
          pagination={{ pageSize: 10 }}
          locale={{ emptyText: "No paid expenses yet" }}
        />
      </Card>
    </DashboardLayout>
  );
};

export default ExpensePaymentReport;
